export type LoadingSpaceRow = Record<number, (string | number | boolean)[]>;

export type UniKey = Record<string, string | number>;

export enum TrueFalse {
  'TRUE' = 'Y',
  'FALSE' = 'N',
}

export enum CsvColumns {
  CONFIG_UNITS = 'CONFIG_UNITS',
  STOP_NAME = 'STOP_NAME',
  SPACE_NAME = 'SPACE_NAME',
  LENGTH = 'LENGTH',
  WIDTH = 'WIDTH',
  HEIGHT = 'HEIGHT',
  LIMIT = 'CAPACITY',
  IS_SET = 'IS_SET',
  LOADING_TYPE = 'LOADING_SPACE_TYPE',
  LOADING_SIDE = 'LOADING_SIDE',
  AXIS_DISTANCE_FROM_FRONT = 'AXIS_DISTANCE_FROM_FRONT',
  AXIS_2_DISTANCE_FROM_FRONT = 'AXIS_2_DISTANCE_FROM_FRONT',
  AXIS_3_DISTANCE_FROM_FRONT = 'AXIS_3_DISTANCE_FROM_FRONT',
  AXIS_EMPTY_SPACE_LOAD = 'AXIS_EMPTY_SPACE_LOAD',
  AXIS_2_EMPTY_SPACE_LOAD = 'AXIS_2_EMPTY_SPACE_LOAD',
  AXIS_3_EMPTY_SPACE_LOAD = 'AXIS_3_EMPTY_SPACE_LOAD',
  // AXIS_LOADING_SPACE_PART = 'AXIS_LOADING_SPACE_PART',
  // AXIS_2_LOADING_SPACE_PART = 'AXIS_2_LOADING_SPACE_PART',
  AXIS_MAX_LOAD = 'AXIS_MAX_LOAD',
  AXIS_2_MAX_LOAD = 'AXIS_2_MAX_LOAD',
  AXIS_3_MAX_LOAD = 'AXIS_3_MAX_LOAD',
  COOLER_WIDTH = 'COOLER_WIDTH',
  COOLER_HEIGHT = 'COOLER_HEIGHT',
  COOLER_LENGTH = 'COOLER_LENGTH',
  COOLER_FLOOR_HEIGHT = 'COOLER_FLOOR_HEIGHT',
  WHEEL_WIDTH = 'WHEEL_WIDTH',
  WHEEL_HEIGHT = 'WHEEL_HEIGHT',
  WHEEL_LENGTH = 'WHEEL_LENGTH',
  WHEEL_DISTANCE = 'WHEEL_DISTANCE',
  VARIO_FLOOR_HEIGHT = 'VARIO_FLOOR_HEIGHT',
  VARIO_FLOOR_THICKNESS = 'VARIO_FLOOR_THICKNESS',
  VARIO_FLOOR_CAPACITY = 'VARIO_FLOOR_CAPACITY',
  LOAD_NAME = 'LOAD_NAME',
  LOAD_TYPE = 'LOAD_TYPE',
  DIAMETER = 'DIAMETER',
  WEIGHT = 'WEIGHT',
  STACKING = 'STACKING',
  QUANTITY = 'QUANTITY',
  MAX_LOADS_ON_TOP = 'STACK_QUANTITY',
  MAX_WEIGHT_ON_TOP = 'MAX_WEIGHT_ON_TOP',
  ALONG_FLOOR = 'ALONG_FLOOR',
  PCT_SUPPORT = 'SUPPORT_LEVEL',
  FORMATION = 'OVAL_FORMATION',
  ALLOW_OUT_OF_SPACE = 'ALLOW_OUT_OF_SPACE',
  ALLOW_TO_ROTATE = 'DO_NOT_ALLOW_TO_ROTATE',
  ROTATE_ON_BASE = 'ROTATE_ON_BASE',
  ROTATE_FREELY = 'ROTATE_FREELY',
  CENTER_OF_MASS_X = 'CENTER_OF_MASS_X',
  CENTER_OF_MASS_Y = 'CENTER_OF_MASS_Y',
  CENTER_OF_MASS_Z = 'CENTER_OF_MASS_Z',
  STREET = 'STREET',
  CITY = 'CITY',
  POSTAL_CODE = 'POSTAL_CODE',
  COUNTRY = 'COUNTRY',
  AIR_BASE_B = 'AIR_BASE_B',
  AIR_HEIGHT_C = 'AIR_HEIGHT_C',
  AIR_HEIGHT_D = 'AIR_HEIGHT_D',
  AIR_LENGTH_A = 'AIR_LENGTH_A',
  AIR_TYPE = 'AIR_TYPE',
  AIR_WIDTH = 'AIR_WIDTH',
  GRAVITY_SHOW_CENTER = 'GRAVITY_SHOW_CENTER',
  GRAVITY_LENGTH_TOLERANCE = 'GRAVITY_LENGTH_TOLERANCE',
  GRAVITY_WIDTH_TOLERANCE = 'GRAVITY_WIDTH_TOLERANCE',
  GRAVITY_CONTAINER_WEIGHT = 'GRAVITY_CONTAINER_WEIGHT',
  PALLET_WEIGHT = 'PALLET_WEIGHT',
  PALLET_MAX_HEIGHT = 'PALLET_MAX_HEIGHT',
  PALLET_MAX_WEIGHT = 'PALLET_MAX_WEIGHT',
  PALLET_HEIGHT = 'PALLET_HEIGHT',
  UNLOADING_STOP = 'UNLOADING_STOP',
  LOAD_ID = 'LOAD_ID',
  DOOR_HEIGHT = 'DOOR_HEIGHT',
  DOOR_WIDTH = 'DOOR_WIDTH',
}

export enum LoadingSpaceType {
  Vehicle = 1,
  SeaContainer = 2,
  Pallet = 3,
  AirContainer = 4,
}

export interface StopInfo {
  address: string | boolean | undefined;
  city: string | boolean | undefined;
  country: string | boolean | undefined;
  name: string | boolean | undefined;
  postalCode: string | boolean | undefined;
}

export interface ProjectData {
  isStops: boolean;
  unit: string;
  stops: CurrentWorkSpace[];
}

export interface LoadGroup {
  name: string;
  length: string | number;
  width: string | number;
  height: string | number;
  weight: string | number;
  stacking: string | boolean;
  color: number;
  loadId?: string | number;
  stopId?: string | number;
  loadType: string | number;
  unloadingOnStop?: string | number;
  destination?: any;
  load?: LoadGroup;
  loadingPlaces: any;
}

export interface LoadSpace {
  loadGroups: LoadGroup[];
}

export interface CurrentWorkSpace {
  loadingSpace: LoadSpace;
  loadingSpaceSet?: LoadSpace;
  unloadingSpace?: LoadGroup[][];
  stops?: StopInfo[];
}

export interface ConvertedLoadGroup {
  load: LoadGroup;
  stopId?: number;
  quantity: number;
}

export interface LoadGroupToAdd {
  currentWorkSpaceId: number;
  newLoads: LoadGroup[];
  unloadingSpace?: LoadGroup[];
  workSpaceId: number;
  currentStopId?: number;
}

export interface LoadingSpaceInterface {
  name: string;
  length: number;
  width: number;
  height: number;
  limit: number;
  set: boolean;
  type: number;
  loadGroups: LoadGroup[];
  loadGroupsSet?: LoadGroup[];
  width1?: string | number;
  height1?: string | number;
  length1?: string | number;
  limit1?: string | number;
  semiTrailerLoadingSide?: string | number;
  coolerSemiTrailerWidth?: string | number;
  coolerSemiTrailerHeight?: string | number;
  coolerSemiTrailerLength?: string | number;
  coolerSemiTrailerFloorHeight?: string | number;
  wheelSemiTrailerWidth?: string | number;
  wheelSemiTrailerHeight?: string | number;
  wheelSemiTrailerDistance?: string | number;
  wheelSemiTrailerLength?: string | number;
  semiTrailerDoorWidth?: string | number;
  varioSemiTrailerFloorHeight?: string | number;
  semiTrailerDoorHeight?: string | number;
  varioSemiTrailerFloorThickness?: string | number;
  varioSemiTrailerFloorCapacity?: string | number;
  gravitySemiTrailerLengthTolerance?: string | number;
  gravitySemiTrailerWidthTolerance?: string | number;
  semiTrailerContainerWeight?: string | number;
  unloadingSpace?: LoadGroup[];
}

export interface LoadingSpaceToAddInterface {
  currentWorkSpaceId: number | undefined;
  newLoadingSpaces: {
    quantity: number;
    loadingSpace: LoadingSpaceInterface;
    stops?: StopInfo[];
  };
}

export interface RemappedData {
  isLoadingSpace?: boolean;
  isLoad?: boolean;
  isConfig?: boolean;
  isStop?: boolean;

  [key: string]: string | boolean | undefined;
}
